import { render } from "./ZigzagServiceLayout.vue?vue&type=template&id=4867100c&scoped=true"
import script from "./ZigzagServiceLayout.vue?vue&type=script&lang=js"
export * from "./ZigzagServiceLayout.vue?vue&type=script&lang=js"

import "./ZigzagServiceLayout.vue?vue&type=style&index=0&id=4867100c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4867100c"]])

export default __exports__